import * as React from "react"
import { CloseIcon } from "@design/icons/material-symbols"
import { Avatar, AvatarBadge } from "@design/ui/avatar"

export interface ModalBXsU9PJPGdHkA5xZcxCesE171320094Wiring {
  modalHeaderContent?: React.ReactNode
  close: React.ComponentProps<typeof CloseIcon>
  modalContent?: React.ReactNode
  tableSlot?: React.ReactNode
  avatar?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarShowBadge?: boolean
  avatarBadge?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName?: string
  profileCardBody?: string
  avatar2?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarShowBadge2?: boolean
  avatarBadge2?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName2?: string
  profileCardBody2?: string
  avatar3?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarShowBadge3?: boolean
  avatarBadge3?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName3?: string
  profileCardBody3?: string
  avatar4?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarShowBadge4?: boolean
  avatarBadge4?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName4?: string
  profileCardBody4?: string
  selectShowIcon?: boolean
  selectPlaceholder?: string
  selectShowIcon2?: boolean
  selectPlaceholder2?: string
  selectShowIcon3?: boolean
  selectPlaceholder3?: string
  selectShowIcon4?: boolean
  selectPlaceholder4?: string
  tableSlot2?: React.ReactNode
  avatar5?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText?: string
  avatarShowBadge5?: boolean
  avatarBadge5?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName5?: string
  profileCardBody5?: string
  avatar6?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText2?: string
  avatarShowBadge6?: boolean
  avatarBadge6?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName6?: string
  profileCardBody6?: string
  avatar7?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText3?: string
  avatarShowBadge7?: boolean
  avatarBadge7?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName7?: string
  profileCardBody7?: string
  avatar8?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText4?: string
  avatarShowBadge8?: boolean
  avatarBadge8?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName8?: string
  profileCardBody8?: string
  avatar9?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText5?: string
  avatarShowBadge9?: boolean
  avatarBadge9?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName9?: string
  profileCardBody9?: string
  avatar10?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText6?: string
  avatarShowBadge10?: boolean
  avatarBadge10?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName10?: string
  profileCardBody10?: string
  avatar11?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText7?: string
  avatarShowBadge11?: boolean
  avatarBadge11?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName11?: string
  profileCardBody11?: string
  selectShowIcon5?: boolean
  selectPlaceholder5?: string
  selectShowIcon6?: boolean
  selectPlaceholder6?: string
  selectShowIcon7?: boolean
  selectPlaceholder7?: string
  selectShowIcon8?: boolean
  selectPlaceholder8?: string
  selectShowIcon9?: boolean
  selectPlaceholder9?: string
  selectShowIcon10?: boolean
  selectPlaceholder10?: string
  selectShowIcon11?: boolean
  selectPlaceholder11?: string
  selectShowIcon12?: boolean
  selectPlaceholder12?: string
  selectShowIcon13?: boolean
  selectPlaceholder13?: string
  selectShowIcon14?: boolean
  selectPlaceholder14?: string
  selectShowIcon15?: boolean
  selectPlaceholder15?: string
  selectShowIcon16?: boolean
  selectPlaceholder16?: string
  selectShowIcon17?: boolean
  selectPlaceholder17?: string
  selectShowIcon18?: boolean
  selectPlaceholder18?: string
  selectShowIcon19?: boolean
  selectPlaceholder19?: string
  avatar12?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText8?: string
  avatarShowBadge12?: boolean
  avatarBadge12?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName12?: string
  profileCardBody12?: string
  avatar13?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText9?: string
  avatarShowBadge13?: boolean
  avatarBadge13?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName13?: string
  profileCardBody13?: string
  avatar14?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText10?: string
  avatarShowBadge14?: boolean
  avatarBadge14?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName14?: string
  profileCardBody14?: string
  avatar15?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText11?: string
  avatarShowBadge15?: boolean
  avatarBadge15?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName15?: string
  profileCardBody15?: string
  avatar16?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText12?: string
  avatarShowBadge16?: boolean
  avatarBadge16?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName16?: string
  profileCardBody16?: string
  avatar17?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText13?: string
  avatarShowBadge17?: boolean
  avatarBadge17?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName17?: string
  profileCardBody17?: string
  avatar18?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText14?: string
  avatarShowBadge18?: boolean
  avatarBadge18?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName18?: string
  profileCardBody18?: string
  avatar19?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText15?: string
  avatarShowBadge19?: boolean
  avatarBadge19?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  profileCardName19?: string
  profileCardBody19?: string
}

export const ModalBXsU9PJPGdHkA5xZcxCesE171320094Context = React.createContext<ModalBXsU9PJPGdHkA5xZcxCesE171320094Wiring | null>(null)

export function useWiring(): ModalBXsU9PJPGdHkA5xZcxCesE171320094Wiring {
  const wiring = React.useContext(ModalBXsU9PJPGdHkA5xZcxCesE171320094Context)
  if (wiring === null) {
    throw new Error("ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen: render inside <ModalBXsU9PJPGdHkA5xZcxCesE171320094Context.Provider>")
  }
  return wiring
}
